/*
  Which release the footer shows. The web build and the API each carry a release: the
  latest tag in their repo and the day they were published. The footer shows the larger
  version and the later date of the two, so a release of either one moves it forward.
*/

const apiBaseUrl =
  process.env.REACT_APP_USE_LOCAL_API_URL === "true"
    ? process.env.REACT_APP_LOCAL_API_URL
    : process.env.REACT_APP_EXTERNAL_API_URL;

// Stamped into the build by the publish action; both are empty in local development
export const webRelease = () => ({
  version: process.env.REACT_APP_RELEASE_VERSION || null,
  date: process.env.REACT_APP_RELEASE_DATE || null,
});

const versionParts = (version) =>
  version
    .replace(/^v/, "")
    .split(".")
    .map((part) => parseInt(part, 10) || 0);

// Compares "v1.2.10" with "v1.3.0" number by number, so v1.2.10 counts as newer than v1.2.9
export const compareVersions = (a, b) => {
  const left = versionParts(a);
  const right = versionParts(b);
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const difference = (left[i] ?? 0) - (right[i] ?? 0);
    if (difference !== 0) return difference;
  }
  return 0;
};

// The larger version and the later date, each taken from whichever release has it
export const newestRelease = (...releases) => {
  const versions = releases.map((release) => release?.version).filter(Boolean);
  const dates = releases.map((release) => release?.date).filter(Boolean);
  return {
    version: versions.sort(compareVersions).pop() ?? null,
    date: dates.sort().pop() ?? null,
  };
};

let apiRelease = null;

// Asked once per page load. Any failure just means the footer goes by the web release.
export const fetchApiRelease = () => {
  if (!apiRelease) {
    apiRelease = fetch(`${apiBaseUrl}/release`)
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);
  }
  return apiRelease;
};
